<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>官方行銷活動
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>官方行銷活動</h1>

        <div class="mt-4">
          <p>
            今年「展昭寵物展」期望透過展覽帶動廠商業績並擴大品牌知名度，更期許能透過產業的多元性，不僅能照顧到飼養狗貓的飼主，更能擴展至特寵圈(涵蓋鼠、兔、鳥)，攜手打造多元共融的寵物宇宙「Petniverse」！
          </p>
          <p>
            這次展昭寵物展以「Petniverse」為主軸，規劃一系列的主題活動並提供不同的曝光資源，邀請您一同加入我們的相關活動，以下開放參展廠商報名。
          </p>
        </div>

        <p class="clear"></p>

        <div class="row mt-5">
          <div
            v-for="item in campaignList"
            :key="item.eventID"
            class="col-md-4 border p-4 mb-3 card-campaign"
          >
            <h3>{{ item.EventName }}</h3>

            <div class="mt-3 ellipsis2">
              {{ item.EventSummary }}
            </div>

            <div class="text-right btn-wrapper">
              <div
                class="btn btn-primary"
                @click="toCampaignDetail(item.EventID, item.EventType)"
              >
                我要報名
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <h3>行銷部聯絡窗口</h3>

          <div class="mt-2">展昭國際企業股份有限公司</div>
          <div>Chan Chao International Co., Ltd.</div>
          <div>Tel: +886-2-2659-6000</div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: "官方行銷活動 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      campaignList: [],
    };
  },

  methods: {
    toCampaignDetail(eventID, eventType) {
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignDetail?no=${this.RegNo}&eventID=${eventID}&eventType=${eventType}`;
    },
  },

  created() {
    const vm = this;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1];

    let lang = "tw";

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });
    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        console.log(response);
        vm.campaignList = response.data.Data;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/Exhibitor/ContactInfo/${vm.RegNo}`,
      )
      .then((response) => {
        console.log(response);
        // vm.campaignList = response.data.Data;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/Exhibitor/RegistrationInfo/${vm.RegNo}`,
      )
      .then((response) => {
        console.log(response);
        // vm.campaignList = response.data.Data;
      });
  },
};
</script>

<style lang="scss">
@import "./../../../assets/helper/table.css";
@import "./../../../assets/helper/fancybox.css";

@media (min-width: 768px) {
  .col-md-4 {
    flex: 0 0 30.333333%;
    max-width: 33.3333333333%;
  }
}

/* 標題超出設定... */
.ellipsis2 {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 顯示三行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; /* 超出顯示 ... */
  white-space: normal; /* 確保文字可以換行 */
  word-break: break-all; /* 預防長英文網址或單字撐開容器 */
}

.card-campaign {
  position: relative; /* 必須設定，讓按鈕能以這格為基準定位 */
  height: 210px; /* 設定你想要的固定高度 */
}

.btn-wrapper {
  position: absolute; /* 絕對定位 */
  bottom: 10px; /* 距離底部剛好 7px */
  right: 20px; /* 距離右邊一點距離，配合你的 p-4 */
  width: calc(
    100% - 40px
  ); /* 讓容器寬度扣掉兩邊 Padding，確保 text-right 生效 */
}
</style>
